import { Button, Card, CardContent, Grid } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import React from 'react';
import useAuth from 'app/hooks/useAuth';

const buttonStyles = {
  color: '#183253',
  fontSize: '18px',
  width: '200px',
  backgroundColor: '#f3f3f3',
  boxShadow: 'none',
  '&:hover': {
    color: '#66b5a3',
    boxShadow: 'none',
    backgroundColor: '#f2faf8'
  }
};
const activeButtonStyles = {
  color: '#66b5a3',
  backgroundColor: '#f2faf8'
};

function PatButtons() {
  const location = useLocation();
  const { patientId, user } = useAuth();
  const patient = patientId;
  
  const isButtonActive = (buttonTo) => location.pathname === buttonTo;
  return (
    <Grid item xs={12} sm={5} md={4} lg={3}>
      <Card style={{ padding: '10px' }}>
        <CardContent>
          <Grid container spacing={2} direction="column" alignItems="center">
            <Grid item>
              <h4> {patient ? patient?.patientName : user?.selectedPatientName}</h4>
            </Grid>

            <Grid item>
              <Button
                component={Link}
                to="/patient/details"
                variant="contained "
                sx={
                  isButtonActive('/patient/details')
                    ? { ...buttonStyles, ...activeButtonStyles }
                    : buttonStyles
                }
              >
                View Patient
              </Button>
            </Grid>
            <Grid item>
              <Button
                component={Link}
                to="/patient/findings"
                variant="contained"
                sx={
                  isButtonActive('/patient/findings')
                    ? { ...buttonStyles, ...activeButtonStyles }
                    : buttonStyles
                }
              >
                Findings
              </Button>
            </Grid>
            <Grid item>
              <Button
                component={Link}
                to="/patient/investigation"
                variant="contained"
                sx={
                  isButtonActive('/patient/investigation')
                    ? { ...buttonStyles, ...activeButtonStyles }
                    : buttonStyles
                }
              >
                Investigation
              </Button>
            </Grid>
            <Grid item>
              <Button
                component={Link}
                to="/patient/treatment"
                variant="contained"
                sx={
                  isButtonActive('/patient/treatment')
                    ? { ...buttonStyles, ...activeButtonStyles }
                    : buttonStyles
                }
              >
                Treatment
              </Button>
            </Grid>
            <Grid item>
              <Button
                component={Link}
                to="/patient/accounts"
                variant="contained"
                sx={
                  isButtonActive('/patient/accounts')
                    ? { ...buttonStyles, ...activeButtonStyles }
                    : buttonStyles
                }
              >
                Accounts
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
}

export default PatButtons;
